import { render } from "./Grafmonumenten.vue?vue&type=template&id=6ea73852"
import script from "./Grafmonumenten.vue?vue&type=script&lang=js"
export * from "./Grafmonumenten.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__